// app/_components/KlaroClient.tsx
"use client";

import { useEffect } from "react";
import klaroConfig from "../klaro-config";

export default function KlaroClient() {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://cdn.kiprotect.com/klaro/v0.7.21/klaro.js";
        script.async = true;
        script.onload = () => {
            if ((window as any).klaro) {
                (window as any).klaro.setup(klaroConfig);
            }
        };
        document.body.appendChild(script);
    }, []);

    return <div id="cookie-banner" />;
}
